<app-bread-crump [title]="('Nav.libraries' | translate)" [description]="('breadcrumps.bibliosDescription' | translate)"
  [items]="[
    { label:('Nav.Home' | translate), url: '/home' },
    { label:('Nav.libraries' | translate) }
  ]">
</app-bread-crump>

<section aria-label="search" class="container search-section">
  <app-search-bar [isAdvancedSearchAvailable]="false" placeholder="search bar..." [value]="(searchQuery$ | async) ?? ''" (search)="onSearchChange($event)"
    (toggleAdvanced)="toggleFilterPanel()">
  </app-search-bar>
</section>

<div class="libraries-layout container">
  <main>
    <!-- Loading State -->
    @if (loading$ | async) {
    <app-skeleton-card [count]="6"></app-skeleton-card>
    }

    <!-- Error State -->
    @if (error$ | async; as error) {
    <app-error-state [error]="error" (retry)="onRetry()">
    </app-error-state>
    }

    <!-- Empty State -->
    @if (isEmpty$ | async) {
    <app-empty-state [searchTerm]="(searchQuery$ | async) ?? ''"
      [hasActiveFilters]="((activeFilters$ | async)?.length ?? 0) > 0" (clearSearch)="onClearSearch()"
      (clearFilters)="onClearAllFilters()">
    </app-empty-state>
    }

    <!-- Results Grid -->
    @if (!(loading$ | async) && !(error$ | async) && !(isEmpty$ | async)) {
    <div class="library-list row g-3">
      @if((items$ | async)?.length) {
        @for (library of items$ | async; track library.library_id) {
        <div class="col-md-4 col-sm-12 col-12">
          <app-libraries-card [library]="library"></app-libraries-card>
        </div>
        }
      }
    </div>
    }

    <!-- Pagination -->
    @if ((pagination$ | async)?.totalPages! > 1) {
    <app-browse-paginator [pagination]="(pagination$ | async)!" (pageChange)="onPageChange($event)">
    </app-browse-paginator>
    }
  </main>

  <aside>
    <app-filter-panel 
      [isFilterPanelOpen]="isFilterPanelOpen" 
      [filterGroups]="(filterGroups$ | async) ?? []" 
      (filterToggle)="onFilterToggle($event.groupKey, $event.value)" 
      (searchFacet)="onSearchFacet($event)"
      (loadMoreFacet)="onLoadMoreFacet($event)"
      (clearAll)="onClearAllFilters()"
      (closePanel)="isFilterPanelOpen = false"
      (closeFilterPanel)="isFilterPanelOpen = false"
      (applyFilters)="isFilterPanelOpen = false">
    </app-filter-panel>
  </aside>
</div>